var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tickets',{attrs:{"tickets":_vm.tickets,"epos":_vm.epos}})
}
var staticRenderFns = []

export { render, staticRenderFns }